import { useState } from "react";

const ExpandableItem = (props) => {
  const [openView, setOpenView] = useState(false);

  return props.render({ openView, setOpenView });
};

export default ExpandableItem;
